export class Tag{
    id: number = 0;
    name: string | undefined;
}